// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__C4VyF","navLink":"navbar_navLink__TPPHd","siteTitle":"navbar_siteTitle__vuT9a","logo":"navbar_logo__1Dwfc","searchIcon":"navbar_searchIcon__tQbAI"};